/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function Assetpanel(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'Assetpanel',
      'aria-hidden': true,
      focusable: false,
      width:  20 * scale,
      height: 18 * scale,
      viewBox: '0 0 20 18',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"M13.557.736a1 1 0 0 0-1.23-.701L.749 3.137A1 1 0 0 0 .034 4.36l2.332 8.701a1 1 0 0 0 1.23.701L4 13.654V6.003A2 2 0 0 1 5.994 4h8.437zM7.007 6h11.986A1 1 0 0 1 20 6.996v10.008a1 1 0 0 1-1.007.996H7.007A1 1 0 0 1 6 17.004V6.996A1 1 0 0 1 7.007 6M18 9.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M8 12l3.5-3 7 7H8z","fill":"currentColor","fillRule":"evenodd"}))
}
